<template>
  <div class="content">
    <div class="box">
      <span>首页</span>
      <span>/{{ routeName }}</span>
    </div>
  </div>
</template>

<script>
import UrlParam from '../../util/urlParamsUtilSync'
export default {
  name: 'bread-crumbs',
  data () {
    return {
      routeName: ''
    }
  },
  created () {
    this.routeName = this.$route.query.linkname || this.$route.meta.name
    console.log('nnnnnnnnnnnnnnnnnnnn',this.routeName);
    let condition = decodeURIComponent(UrlParam(window.location.href, 'name')[0]);
    if (condition == '认证答疑') {
      this.routeName = '领事认证/认证答疑'
    } else if (condition == '认证简介') {
      this.routeName = '领事认证/认证简介'
    } else if (condition == '认证信息') {
      this.routeName = '领事认证/认证信息'
    } else if (condition == '签证信息') {
      this.routeName = '出国签证/签证信息'
    }
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  height: 70px;
  border-bottom: 1px solid #eeeeee;
  position: relative;
}
.box {
  // position: absolute;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  width: 1140px;
  text-align: left;
  line-height: 70px;
  span {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #7f7f7f;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/breadCrumbs.vue